import axiosIns from '@axios'

const $http = axiosIns

// Sign Comments
export const $createChatMessage = async (payload: object) => {
  return await $http.post('chat-messages/', payload)
}

export const $bulkCreateChatMessages = async (payload: object) => {
  return await $http.post('chat-messages/bulk-create/', payload)
}

export const $updateChatMessage = async (id: number | string, payload: object) => {
  return await $http.patch(`chat-messages${id}/`, payload)
}

export const $deleteChatMessage = async (id: number | string) => {
  return await $http.delete(`chat-messages${id}/`)
}

export const $getChatMessage = async (id: number | string) => {
  return await $http.get(`chat-messages${id}/`)
}

export const $getChatMessages = async (params: object) => {
  return await $http.get('chat-messages/', { params: params })
}
